<script>
import {mapState} from "vuex";

export default {
  name: "DigitalSignCard",
  emits: ["click"],
  props: {
    isMain: {
      type: Boolean,
      default: true
    },
    contract: {
      type: Object,
      default: () => null
    }
  },
  computed: {
    user() {
      return this.$store.getters['user/user'];
    },
    isSignable() {
      if(!this.isMain && this.user && this.user.mod_key){
        return false
      }
      if (this.contract) {
        return this.contract.status !== 'user_signed' && this.contract.status !== 'admin_signed'
      } else {
        return true
      }
    },
    isSigned() {
      if(!this.isMain && this.user && this.user.mod_key){
        return true
      }
      if (this.contract) {
        return this.contract.status === 'user_signed' || this.contract.status === 'admin_signed';
      } else {
        return false
      }
    }
  }
}
</script>

<template>
  <div class="out" :class="{
      'success': isSigned,
    }">
    <i class="sr sr-check checkIcon mt-1 mr-1"/>
    <div class="sign-card" :class="{
      'success': isSigned,
    }">
      <h4 class="card-title">{{ $t('contract.by_entering_into_this') }}</h4>
      <p class="card-text" v-if="isMain" v-html="$t('contract.trade_participation_rights')">

      </p>
      <p class="card-text" v-else v-html="$t('kyc.dividend_withdrawal_rights')">
      </p>
      <ic-button class="card-button" size="tn" :disabled="!isSignable" @click="$emit('click')">
        <template v-if="isSigned">
          {{ $t('contract.contract_signed') }}
        </template>
        <template v-else>
          {{ $t('kyc.sign_contract_electronically') }}
        </template>
      </ic-button>
    </div>
  </div>
</template>

<style lang="scss" src="./kyc.scss"></style>
